<div class="container">


  <div fxLayout="row wrap" fxLayoutAlign="baseline" fxLayoutAlign.md="center center"fxLayoutAlign.sm="center center" fxLayoutAlign.xs="center center">


    <div class="pricingbox" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="90" fxFlex.xs="90">
      <div class="price pricetot">
        <h2>Total Cost: {{ totalPrice | number:'1.0-0' }}€</h2>
        <h4>Total duration of the service: {{ serviceDuration }} month(s)</h4>

        <div class="pricexl">EDClin: {{ initialPrice | number:'1.0-0' }}€</div>
        <div class="pricexs">
          <span *ngIf="nbMonthPayment == 3">Payment in full within first 3 months from the contract signature</span>
          <span *ngIf="nbMonthPayment == 6">Payment in full within first 6 months from the contract signature</span>
        </div>

        <br>

        <div class="pricexl">Hosting & Support: {{ hostingSupportTotalPrice | number:'1.0-0' }}€</div>
        <div class="pricexs"><span> Payment schedule: {{monthHostingSupport}}€/month during {{ nbMonthHosting }} months</span></div>
      </div>

      <div class="pricingdeets">
        <div class="part" (click)="selectPart($event, 'CRFstate')" [ngClass]="{'active' : CRFstate}">
          <p>Users & CRF versions</p>
          <hr>
          <h1>1</h1>
        </div>

        <div class="part" (click)="selectPart($event, 'HostingState')" [ngClass]="{'active' : HostingState}">
          <p>Hosting & Support</p>
          <hr>
          <h1>2</h1>
        </div>

        <div class="part" (click)="selectPart($event, 'CodingState')" [ngClass]="{'active' : CodingState}">
          <p>Coding — Files Support</p>
          <hr>
          <h1>3</h1>
        </div>

        <div class="part" (click)="selectPart($event, 'SummaryState')" [ngClass]="{'active' : SummaryState}">
          <p>Summary</p>
          <hr>
          <h1>4</h1>
        </div>
      </div>

      <!-- <div class="formulaName">
        <p>Your Plan</p>
        <h1 class="nameh1">{{name}}</h1>
      </div> -->
    </div>


    <div fxFlex.xl="65" fxFlex.lg="65" fxFlex.md="65" fxFlex.sm="90" fxFlex.xs="90" class="form">
      <div *ngIf="currentPage==='CRFstate'" [formGroup]="pricingForm">
        <!-- <ng-template matStepLabel>Users & CRF Versions</ng-template> -->
        <div class="custom-slider">
          <h2>Users — <span> {{ pricingForm.controls['users'].value }}</span>
          </h2>
          <ng5-slider #users formControlName="users" (ngModelChange)="checkForm()" [options]="option1"></ng5-slider>
        </div>

        <div class="custom-slider">
          <h2>Patients — <span> {{ pricingForm.controls['patients'].value }} </span>
          </h2>
          <ng5-slider #patients formControlName="patients" (ngModelChange)="checkForm()" [options]="option2">
          </ng5-slider>
        </div>

        <div class="custom-slider">
          <h2>CRF Versions — <span> {{ pricingForm.controls['crfVersions'].value }} </span>
          </h2>
          <ng5-slider matTooltipClass="tooltip" #crf formControlName="crfVersions" (ngModelChange)="checkForm()"
            [options]="option3"></ng5-slider>
        </div>

        <div class="custom-slider">
          <h2>Automatic Queries — <span> {{ pricingForm.controls['autoQuerries'].value }} </span>
          </h2>
          <ng5-slider matTooltipClass="tooltip" #autoQuerries formControlName="autoQuerries"
            (ngModelChange)="checkForm()" [options]="option7"></ng5-slider>
        </div>

        <div class="buttons">
          <button mat-flat-button class="btn-hover color-3"
            (click)="selectPart($event, 'HostingState')"><span>Next</span></button>
        </div>
      </div>

      <div *ngIf="currentPage==='HostingState'" [formGroup]="pricingForm">

        <div *ngIf="prechecked" class="custom-slider-pub">
          <h2>Hosting type <span> — Mutualized</span></h2>
        </div>

        <div *ngIf="!prechecked" class="custom-slider">
          <h2 *ngIf="!prechecked">Hosting type<span > — {{ pricingForm.controls['server'].value == 1 ? 'Mutualized' : 'Dedicated' }}</span></h2>
          <ng5-slider *ngIf="!prechecked" formControlName="server" (ngModelChange)="checkForm()" [options]="option9"></ng5-slider>
        </div>


        <div class="custom-slider">
          <h2>Hosting & Maintenance duration - Technical Support*<small> (in month)</small></h2>
          <ng5-slider formControlName="hosting" (ngModelChange)="checkForm()" [options]="option4"></ng5-slider>
        </div>

        <!-- <div class="custom-slider">
          <h2>Technical Support**<small> (per month)</small></h2>
          <ng5-slider formControlName="techSupport" (ngModelChange)="checkForm()" [options]="option5"></ng5-slider>
        </div> -->

        <div class="custom-slider">
          <h2>Email Alerts — <span> {{ pricingForm.controls['alerts'].value }} </span></h2>
          <ng5-slider #alerts formControlName="alerts" (ngModelChange)="checkForm()" [options]="option6"></ng5-slider>
        </div>

        <div class="custom-slider">
          <h2>Upload & Deidentification*<small> (in Terabyte)</small></h2>
          <ng5-slider formControlName="upload" (ngModelChange)="checkForm()" [options]="option8"></ng5-slider>
        </div>

        <div class="buttons">
          <button mat-flat-button class="btn-hover color-3"
            (click)="selectPart($event, 'CodingState')"><span>Next</span></button>
          <button mat-flat-button class="outline btn-hover color-3"
            (click)="selectPart($event, 'CRFstate')"><span>Back</span></button>
        </div>
      </div>

      <div *ngIf="currentPage==='CodingState'" [formGroup]="pricingForm">
        <div class="check" fxLayout fxLayout="row" fxLayout.xs="column" fxLayout.sm="column"
          fxLayoutAlign="space-center" fxLayoutAlign.md="center" fxLayoutAlign.sm="center" fxLayoutAlign.xs="center" fxLayoutGap="">


          <div fxFlex fxFlexOffset="15%" fxFlexOffset.md="0%"fxFlexOffset.sm="0%" fxFlexOffset.xs="0%">
            <div class="options">
              <h2>Export</h2>
              <div *ngFor="let data of Export; let i=index">
                <mat-slide-toggle disabled [checked]="data.checked" [name]="data.value"
                  (change)="onCheckboxChange($event,'export')">{{ data.name }}</mat-slide-toggle>
              </div>
            </div>

            <div class="options">
              <h2>e-CRF Sign-off</h2>
              <div *ngFor="let data of SignOff; let i=index">
                <mat-slide-toggle *ngIf="prechecked" [checked]="prechecked" [name]="data.value" [disabled]="prechecked"
                  (change)="onCheckboxChange($event,'signOff')">{{ data.name }}</mat-slide-toggle>
                <mat-slide-toggle *ngIf="!prechecked" [checked]="data.checked" [name]="data.value"
                  (change)="onCheckboxChange($event,'signOff')">{{ data.name }}</mat-slide-toggle>
              </div>
            </div>

            <div class="options">
              <h2>Additional modules</h2>
              <div *ngFor="let data of Adjudication; let i=index">
                <mat-slide-toggle [checked]="data.checked" [name]="data.value"
                  (change)="onCheckboxChange($event,'adjudication')">{{ data.name }}</mat-slide-toggle>
              </div>
            </div>

          </div>

          <div fxFlex fxFlexOffset="10%" fxFlexOffset.md="0%"  fxFlexOffset.sm="0%" fxFlexOffset.xs="0%">
            <div class="options">
              <h2>Metrics</h2>
              <div *ngFor="let data of Metrics; let i=index">
                <mat-slide-toggle *ngIf="prechecked" [checked]="prechecked" [name]="data.value" [disabled]="prechecked"
                  (change)="onCheckboxChange($event,'metrics')">{{ data.name }}</mat-slide-toggle>
                <mat-slide-toggle *ngIf="!prechecked" [checked]="data.checked" [name]="data.value"
                  [disabled]="prechecked" (change)="onCheckboxChange($event,'metrics')">{{ data.name }}
                </mat-slide-toggle>
              </div>
            </div>

            <div class="options">
              <h2>Change Reasons</h2>
              <div *ngFor="let data of ChangeReasons; let i=index">
                <mat-slide-toggle [checked]="data.checked" [name]="data.value"
                  (change)="onCheckboxChange($event,'changeReasons')">{{ data.name }}</mat-slide-toggle>
              </div>
            </div>

            <div class="options">
              <h2>Coding Systems</h2>
              <div *ngFor="let data of CodingSys; let i=index">
                <mat-slide-toggle [checked]="data.checked" [name]="data.value"
                  (change)="onCheckboxChange($event,'codingSys')">{{ data.name }}</mat-slide-toggle>
              </div>
            </div>

            <div class="options">
              <h2>Design</h2>
              <div *ngFor="let data of Design; let i=index">
                <mat-slide-toggle [checked]="data.checked" [name]="data.value"
                  (change)="onCheckboxChange($event,'design')">{{ data.name }}</mat-slide-toggle>
              </div>
            </div>

            <div class="buttons">
              <button mat-flat-button class="btn-hover color-3"
                (click)="selectPart($event, 'SummaryState')"><span>Next</span></button>
              <button mat-flat-button class="outline btn-hover color-3"
                (click)="selectPart($event, 'HostingState')"><span>Back</span></button>
            </div>

          </div>




        </div>


      </div>

      <mat-list *ngIf="currentPage==='SummaryState'" role="list">
        <div class="list" fxLayout fxLayout="row" fxLayoutAlign="center center" fxLayout.xs="column"
          fxLayout.sm="column" fxLayout.md="column"fxLayoutAlign="center" fxLayoutGap="">

          <div fxFlex="50" class="recap-col-1">
            <mat-list-item role="listitem">
              <h2> Users</h2>
              <span>{{ pricingForm.controls['users'].value }}</span>
            </mat-list-item>

            <mat-list-item role="listitem">
              <h2>Patients</h2>
              <span>{{ pricingForm.controls['patients'].value }}</span>
            </mat-list-item>

            <mat-list-item role="listitem">
              <h2>CRF Versions</h2>
              <span>{{ pricingForm.controls['crfVersions'].value }}</span>
            </mat-list-item>

            <mat-list-item role="listitem" *ngIf="pricingForm.controls['changeReasons'].value[0]">
              <h2>Change Reasons</h2>
            </mat-list-item>

            <mat-list-item role="listitem" *ngIf="pricingForm.controls['design'].value[0]">
              <h2>Design<span class="unlimited"> By experts</span></h2>
            </mat-list-item>

            <mat-list-item class="dropdown" role="listitem" *ngIf="pricingForm.controls['export'].value[0]">
              <h2 class="dp-title"> Export</h2>
              <ul class="details">
                <li *ngFor="let data of pricingForm.controls['export'].value; let i=index" class="items">{{data}}
                </li>
              </ul>
            </mat-list-item>

            <mat-list-item role="listitem" class="dropdown" *ngIf="pricingForm.controls['metrics'].value[0]">
              <h2 class="dp-title">Metrics</h2>
              <ul class="details">
                <li *ngFor="let data of pricingForm.controls['metrics'].value; let i=index" class="items">{{data}}
                </li>
              </ul>
            </mat-list-item>

          </div>

          <div fxfxFlex="50" class="recap-col-2">

            <mat-list-item role="listitem">
              <h2>Hosting type</h2>
              <span>{{ pricingForm.controls['server'].value == 1 ? 'Mutualized' : 'Dedicated' }}</span>

            </mat-list-item>

            <mat-list-item role="listitem">
              <h2>Hosting* & Support duration</h2>
              <span>{{ pricingForm.controls['hosting'].value + ' months' }}</span>
            </mat-list-item>

            <!-- <mat-list-item role="listitem">
              <h2>Tech Support</h2>
              <span>{{ pricingForm.controls['techSupport'].value + ' months' }}</span>
            </mat-list-item> -->

            <mat-list-item *ngIf="pricingForm.controls['upload'].value" role="listitem">
              <h2>Upload</h2>
              <span>{{ pricingForm.controls['upload'].value + ' To' }}</span>
            </mat-list-item>

            <mat-list-item class="dropdown" role="listitem" *ngIf="pricingForm.controls['codingSys'].value[0]">
              <h2 class="dp-title">Coding</h2>
              <ul class="details">
                <li *ngFor="let data of pricingForm.controls['codingSys'].value; let i=index" class="items">{{data}}
                </li>
              </ul>
            </mat-list-item>

            <mat-list-item class="dropdown" role="listitem">
              <h2 class="dp-title">Sign-off</h2>
              <ul class="details">
                <li *ngFor="let data of pricingForm.controls['signOff'].value; let i=index" class="items">{{data}}
                </li>
              </ul>
            </mat-list-item>

            <mat-list-item class="dropdown" role="listitem" *ngIf="pricingForm.controls['adjudication'].value[0]">
              <h2 class="dp-title">Additional modules</h2>
              <ul class="details">
                <li *ngFor="let data of pricingForm.controls['adjudication'].value; let i=index" class="items">
                  {{data}}</li>
              </ul>
            </mat-list-item>
          </div>
        </div>
        <div class="buttons">
          <button mat-flat-button class="btn-hover color-3" (click)="onSubmit()"><span>Submit</span></button>
          <button mat-flat-button class="outline btn-hover color-3"
            (click)="selectPart($event, 'CodingState')"><span>Back</span></button>
          <button mat-flat-button class="pdfButton btn-hover color-3" (click)="generatePdf()"><span>Generate
              PDF</span></button>
        </div>
      </mat-list>

    </div>
